import ALAPA from '../assets/img/alapa.png';
import mencionCIPDH from '../assets/img/mencion-CIPDH.jpg';
import unesco from '../assets/img/unesco.png'

export interface RecognitionItem {
    year: number;
    award: string;
    organization?: string;
    img: string; // Assuming this is a path to an image
    alt: string;
}

export const recognitions: RecognitionItem[] = [
    {
        year: 2025,
        organization: 'ALAPA',
        award: 'Premio por la inclusión y la visibilización de Enfermedades Poco Frecuentes',
        img: ALAPA,
        alt: 'alapa'
    },
    {
        year: 2024,
        organization: 'UNESCO',
        award: 'Mención especial del Premio Construir Igualdad',
        img: mencionCIPDH,
        alt: 'UNESCO '
    },
    {
        year: 2024,
        organization: 'UNESCO',
        award: 'Reconocimiento como promotores de derechos humanos',
        img: unesco,
        alt: 'UNESCO'
    },
]